<template>
  <div class="cagura-wrapper">
    <div class="input-widget">
      <input type="text" v-model="current_time" @click="openPlayer()" class="bg-cagura-form-control" />
    </div>
    <div v-if="show_video_modal" class="movie-container">
      <div class="video-modal">
        <div class="video-modal-body">
          <ClapprPlayer :src="`${$store.state.ASSETS_VIDEO_BASE_URL}movies/${movie}/master.m3u8`" type="hls"
            @progress="onProgress"></ClapprPlayer>
        </div>
        <div class="video-modal-footer">
          <c-button @click="selectTime()" class="btn-success">Select time</c-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "movie-input",
  components: {},
  props: {
    value: {
      type: [Number, String],
      default: 1,
    },
    movie: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show_video_modal: false,
      current_time: 0,
    };
  },
  watch: {},
  mounted() { },
  destroyed() { },
  methods: {
    openPlayer() {
      let vm = this;
      vm.show_video_modal = true;
    },
    onProgress(time) {
      let vm = this;
      vm.current_time = time;
    },
    selectTime() {
      let vm = this;
      vm.show_video_modal = false;
      vm.$emit("input", vm.current_time);
    },
  },
};
</script>


<style lang="scss" scoped>
.cagura-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;

  .movie-container {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 999;
    background: rgba($color: #000000, $alpha: 0.8);
    display: flex;
    justify-content: center;
    padding-top: 80px;

    .video-modal {
      width: 700px;
      height: 550px;
      background: #fff;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      .video-modal-body {
        height: calc(100% - 80px);
        display: flex;
      }

      .video-modal-footer {
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>

